<template>
  <v-layout wrap justify-center align-start px-2>
    <v-flex xs12>
      <title-description :chapterID="$route.params.chapterID" />
      <gallery :images="shownImages" style="margin-top:40px;" />
      <images-input :contentImages="images"></images-input>
    </v-flex>
  </v-layout>
</template>

<script>
import TitleDescription from "./../TitleDescription";
import Gallery from "./Gallery";
import ImagesInput from "./ImagesInput";
import { updateContent } from "@/firebase/api/content";

export default {
  props: {
    content: Object
  },
  mounted() {
    const imagesAreDefined = !!this.content.images;
    const contentWasLoaded = Object.keys(this.content).length > 0;
    if (contentWasLoaded && !imagesAreDefined) {
      const images = [];
      const { chapterID, contentID } = this.$route.params;
      updateContent(chapterID, contentID, { images });
    }
  },

  computed: {
    contentWasLoaded() {
      return Object.keys(this.content).length > 0
    },

    images() {
      return this.contentWasLoaded && !!this.content.images ? this.content.images : []
    },
    shownImages() {
      const mapper = (image, index) => {
        image.index = index;
        return image;
      };
      const images = this.images;
      return images.map(mapper);
    }
  },
  components: { TitleDescription, Gallery, ImagesInput }
};
</script>
